export const VIDEO_LIMITS = {
  MAX_SIZE: 1073741824, // 1GB in bytes
};

export const VIDEO_ERROR_MESSAGES = {
  MAX_SIZE: 'Video must be 1GB Max Size',
  REQUIRED: 'Video is required',
  MESSAGE: 'MP4 ONLY. Max size 1GB',
  FILE_TYPE: 'Only MP4 files are allowed.',
};
